<div class="card" style="margin-bottom: 5rem;">
	<div class="card-header">
		<h1>Carga general de documentos</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="file" class="form-label">Archivo a procesar</label>
				<div class="input-group">
					<input type="file" (change)="onFileChange($event)" #file accept=".zip,.xml" name="file" id="file"
						class="form-control">
				</div>
				<p class="form-text">Ingresa archivos <b>xml</b> o <b>zip</b></p>
			</div>
			<div class="col form-group">
				<label for="anulable" class="form-label">¿Son DTE anulados?</label>
				<div class="input-group">
					<button id="anulable" name="anulable" (click)="anulable = !anulable;"
						[ngClass]="anulable?'btn-primary':'btn-secondary'" class="btn">
						<i [ngClass]="anulable?'fa-toggle-on':'fa-toggle-off'" class="fa"></i></button>
					<input type="text" id="textAnulable" name="textAnulable" [value]="anulable?'SI':'NO'"
						class="form-control">
				</div>
			</div>
			<div class="col form-group" *ngIf="file">
				<label for="" class="form-label" style="text-align: center; width: 100%;">Opciones</label>
				<div class="input-group" style="justify-content: center;">
					<!-- <app-loading-button [object]="buttonPreview" (clicked)="preview()"></app-loading-button> -->
					<app-loading-button [object]="buttonProcess" (clicked)="process()"></app-loading-button>
				</div>
			</div>
		</div>
		<ng-container *ngIf="files.length > 0">
			<hr>
			<h5>Confirmación de archivo a procesar</h5>
			<div class="form-group">
				<label for="" class="form-label">Archivo <i class="fa fa-asterisk text-danger"></i></label>
				<div class="input-group">
					<app-input-autocomplete (inputMethod)="searchFile()"
						(changeStatus)="selectFile($event.filterElement)" [custom]="true" [filterElements]="filterFiles"
						[inputs]="inputFile" custom="true" placeholder="Ingresa un nombre o nit" allBorderRadius="true">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<span class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.fileName}}</span>
								<p style="line-height: normal; margin-bottom: 0;"><small>NIT Emisor
										<b>{{filter.nitEmisor}}</b>
										- NIT
										Receptor <b>{{filter.nitReceptor}}</b></small></p>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
			<div *ngIf="fileSelected">
				<br>
				<h5>Datos generales <b>{{fileSelected.fileName}}</b></h5>
				<div class="row">
					<div class="col form-group">
						<label for="moneda" class="form-label">Moneda</label>
						<input type="text" name="moneda" disabled [value]="fileSelected.currency == 0? 'GTQ':'USD'" id="moneda"
							class="form-control">
					</div>
					<div class="col form-group">
						<label for="fecha" class="form-label">Fecha</label>
						<input type="text" name="fecha" disabled [value]="fileSelected.date" id="fecha"
							class="form-control">
					</div>
					<div class="col form-group">
						<label for="nitEmisor" class="form-label">NIT Emisor</label>
						<input type="text" name="nitEmisor" disabled [value]="fileSelected.nitEmisor" id="nitEmisor"
							class="form-control">
					</div>
					<div class="col form-group">
						<label for="nombreEmisor" class="form-label">Nombre Emisor</label>
						<input type="text" name="nombreEmisor" disabled [value]="fileSelected.nombreEmisor"
							id="nombreEmisor" class="form-control">
					</div>
					<div class="col form-group">
						<label for="nitReceptor" class="form-label">NIT Receptor</label>
						<input type="text" name="nitReceptor" disabled [value]="fileSelected.nitReceptor"
							id="nitReceptor" class="form-control">
					</div>
					<div class="col form-group">
						<label for="nombreReceptor" class="form-label">Nombre Receptor</label>
						<input type="text" name="nombreReceptor" disabled [value]="fileSelected.nombreReceptor"
							id="nombreReceptor" class="form-control">
					</div>
				</div>
				<br>
				<h5>Lineas del documento - Detalle</h5>
				<div class="table-responsive">
					<table class="table table-striped">
						<thead>
							<tr>
								<th>Bien/Serv</th>
								<th>Cantidad</th>
								<th>Unidad Med.</th>
								<th>Descripción</th>
								<th>Precio Unit</th>
								<th>Precio</th>
								<th>Desc.</th>
								<th>Impuesto</th>
								<th>Total</th>
								<th>Seleccionar</th>
							</tr>
						</thead>
						<tbody>
							<tr class="tr-middle" *ngFor="let item of fileSelected.items">
								<td>{{item.type}}</td>
								<td>{{item.quantity}}</td>
								<td>{{item.measureUnit}}</td>
								<td>{{item.description}}</td>
								<td>{{item.unitPrice | currency: 'Q'}}</td>
								<td>{{item.price | currency: 'Q'}}</td>
								<td>{{item.discount | currency: 'Q'}}</td>
								<td>{{item.taxes | currency: 'Q'}}</td>
								<td>{{item.total | currency: 'Q'}}</td>
								<td>
									<i (click)="item.selected = !item.selected"
										[ngClass]="item.selected?'fas fa-square-check text-success':'fa-regular fa-square text-secondary'"
										class="clickeable"></i>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-loading-button [object]="buttonSave" (clicked)="processSelected()"></app-loading-button>
			</div>
		</ng-container>
	</div>
</div>